export default "__VITE_ASSET__CZk599YN__"